import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./componentes/header/header.component";
import { FooterComponent } from "./componentes/footer/footer.component";
import { Router } from '@angular/router';
import { InicioService } from './services/inicio.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{
  title = 'pna_admin';
  public rutas = inject(Router);
  public service = inject(InicioService);
  user: any;
  logeo: boolean = false;
  token: string = ''

  ngOnInit(): void {
    if (typeof window !== 'undefined' && !!localStorage.getItem('token')) {
      const storedUser = localStorage.getItem('usuSesion');
      if (storedUser != null) {
        this.user = JSON.parse(storedUser);
        this.service.updateLogeo(this.user);
      } else {
        // Si no hay usuario almacenado, realizar la lógica de autenticación
        this.user = null;
        this.service.updateLogeo(this.user);
        //console.log('no hay usuario')
      }
    }
    //console.log('no hay usuario: ', this.user)
    this.service.user$.subscribe(user => {
      this.user = user;
    });

    if(this.user){
      this.rutas.navigate(['/panel-admin']);
    }
    else{
      this.rutas.navigate(['/']);
    }

  }


}
